export default __webpack_public_path__ + "static/media/homevaluation.30b27c7e.gif";